<template>
    <div id="a7" class="we-client">
        <div class="we-client-swiper-div" >
            <div @mouseover="khstop(1)" @mouseleave="khstart(1)">
                <swiper class="we-client-swiper" ref="khlb1" :options="swiperOptionsWeClient">
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_1.jpg'">
                    </swiper-slide>
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_2.jpg'">
                    </swiper-slide>
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_3.jpg'">
                    </swiper-slide>
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_4.jpg'">
                    </swiper-slide>
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_5.jpg'">
                    </swiper-slide>
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_6.jpg'">
                    </swiper-slide>
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_7.jpg'">
                    </swiper-slide>
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_8.jpg'">
                    </swiper-slide>
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_9.jpg'">
                    </swiper-slide>
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_10.jpg'">
                    </swiper-slide>
                </swiper>
            </div>
            <div  @mouseover="khstop(2)" @mouseleave="khstart(2)">
                <swiper class="we-client-swiper" ref="khlb2" :options="swiperOptionsWeClient" style="width:106%;margin-left: -6%">
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_11.jpg'">
                    </swiper-slide>
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_12.jpg'">
                    </swiper-slide>
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_13.jpg'">
                    </swiper-slide>
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_14.jpg'">
                    </swiper-slide>
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_15.jpg'">
                    </swiper-slide>
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_16.jpg'">
                    </swiper-slide>
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_17.jpg'">
                    </swiper-slide>
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_18.jpg'">
                    </swiper-slide>
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_19.jpg'">
                    </swiper-slide>
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_20.jpg'">
                    </swiper-slide>
                </swiper>
            </div>
            <div @mouseover="khstop(3)" @mouseleave="khstart(3)">
                <swiper class="we-client-swiper" ref="khlb3" :options="swiperOptionsWeClient">
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_21.jpg'">
                    </swiper-slide>
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_22.jpg'">
                    </swiper-slide>
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_23.jpg'">
                    </swiper-slide>
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_24.jpg'">
                    </swiper-slide>
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_25.jpg'">
                    </swiper-slide>
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_26.jpg'">
                    </swiper-slide>
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_27.jpg'">
                    </swiper-slide>
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_28.jpg'">
                    </swiper-slide>
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_29.jpg'">
                    </swiper-slide>
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_30.jpg'">
                    </swiper-slide>
                </swiper>
            </div>
            <div @mouseover="khstop(4)" @mouseleave="khstart(4)">
                <swiper class="we-client-swiper" ref="khlb4" :options="swiperOptionsWeClient" style="width:106%;margin-left: -6%">
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_31.jpg'">
                    </swiper-slide>
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_32.jpg'">
                    </swiper-slide>
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_33.jpg'">
                    </swiper-slide>
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_34.jpg'">
                    </swiper-slide>
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_35.jpg'">
                    </swiper-slide>
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_36.jpg'">
                    </swiper-slide>
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_37.jpg'">
                    </swiper-slide>
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_38.jpg'">
                    </swiper-slide>
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_39.jpg'">
                    </swiper-slide>
                    <swiper-slide class="we-client-swiper-slide">
                        <img :src="fileServerUrl+'assets/joinlogo/logo_40.jpg'">
                    </swiper-slide>
                </swiper>
            </div>
        </div>

        <div class="client-hover">
            <div class="client-hover-font" >
                <span style="color: #f9b72f; opacity: 1; ">&nbsp;&nbsp;100+</span>
                <span style="color: white; opacity: 1;z-index: 1001;position: relative">
                    机构<br/>
                    对我们的信任
                </span>
            </div>

        </div>
<!--        <div class="client-hover2">-->

<!--        </div>-->
    </div>
</template>

<script>
    export default {
        data() {
            return {
                fileServerUrl:fileServerUrl,
                aboutShow:false,
                aboutPShow:false,
                activeIndex: 1,
                hxywTpHoverIndex:0,//核心业务图片悬浮
                pphdTpHoverIndex:0,//品牌活动图片悬浮
                xmhgTpActive:1,//项目回顾点击的第几个项目
                // swiper配置项:
                swiperOptions: {
                    //效果,特效  默认为"slide"（普通位移切换），还可设置为"fade"（淡入）、"cube"（方块）、"coverflow"（3d流）、"flip"（3d翻转）
                    effect: "slide",
                    // 无限循环
                    loop: true,
                    // 自动滚动
                    // autoplay: true, //默认的效果
                    // 个性化配置
                    autoplay: {
                        delay: 2000, //间隔时长, 单位毫秒
                        disableOnInteraction: false, //用户操作swiper后是否禁用自动滚动
                    },
                    // 分页器: 官方的API文档是 HTML版本的, 与 vue 中用法有细微差异
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true, //响应点击事件
                    },
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                },
                // 我们的客户swiper配置项:
                swiperOptionsWeClient: {
                    slidesPerView:6,
                    spaceBetween:10,
                    freeMode:true,
                    speed:3000,
                    //效果,特效  默认为"slide"（普通位移切换），还可设置为"fade"（淡入）、"cube"（方块）、"coverflow"（3d流）、"flip"（3d翻转）
                    effect: "slide",
                    // 无限循环
                    loop: true,
                    // 自动滚动
                    // autoplay: true, //默认的效果
                    // 个性化配置
                    autoplay: {
                        delay: 0, //间隔时长, 单位毫秒
                        disableOnInteraction: false, //用户操作swiper后是否禁用自动滚动
                        stopOnLastSlide: false,
                    },
                    // 分页器: 官方的API文档是 HTML版本的, 与 vue 中用法有细微差异
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true, //响应点击事件
                    },
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                },
            };
        },
        methods: {
            counter1(item) {
                const returnEle = document.querySelector(item);
                if (!!returnEle) {
                    returnEle.scrollIntoView(true);
                }
                document.querySelector(item).scrollIntoView(true);
            },
            slideChange() {
                this.activeIndex = this.$refs.mySwiper.$swiper.activeIndex
            },
            mouseOver(e){
                // console.log(e)
            },
            mouseLeave(e){
                // console.log(e)
            },
            khstop(index){

                // this.$refs[`khlb`+index].$swiper.autoplay.stop();

            },
            khstart(index){

                // this.$refs[`khlb`+index].$swiper.autoplay.start();

            },
            showHddb(){
                return document.documentElement.scrollTop>=700;
            },
            handleScroll() {
                this.currentScroll = window.pageYOffset //表示当前滚动的位置

                if (this.currentScroll >= this.$refs.aboutUsref.offsetTop - 750) { //当前滚动位置到达testref的时候，显示div（100作为调整用）
                    this.aboutShow = true;
                }else {
                    this.aboutShow = false;
                }

                if (this.currentScroll >= this.$refs.aboutProgram.offsetTop -750) { //当前滚动位置到达testref的时候，显示div（100作为调整用）
                    this.aboutPShow = true;
                }else {
                    this.aboutPShow = false;
                }
            }
        },
    };
</script>

<style lang="scss" scoped>
    .we-client{
        color: #333333;
        //margin-bottom: 40px;
        margin-top: 20px;
        background-color: rgba(216, 219, 255, 0.9);
        //background-color: rgb(60, 46, 138,0.9);
        position: relative;
    }
    .we-client-title {
        padding-top: 12px;
        text-align: center;
        font-weight: bold;
        font-size: 15px;
    }
    .we-client-title span {
        border-bottom: 3px solid #0239be;
    }
    .we-client-swiper-div{
        margin-top: 25px;
        margin-bottom: 23px;
        //width: 100%;
        width: 100%;
        height: 5%;
    }

    .client-hover{
        width: 21%;
        height: 21%;
        position: absolute;
        left:38%;
        top: 35%;
        border-radius: 30px;
        background-color: rgb(60, 46, 138,0.9);
        z-index: 22;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .client-hover2{
        width: 100%;
        height: 100%;
        position: absolute;
        left:0;
        top: 0;
        background-color: rgba(216, 219, 255, 0.5);
        z-index: 21;
    }

    .client-hover-font{
        font-size: 13px;
        font-weight: bold;
        padding-bottom: 1%;
    }

    .we-client-swiper{
        margin-top: 20px;
        margin-left: 15px;
        margin-right: 5px;
        width: 100%;
    }
    .we-client-swiper-slide{
        width: 10%;
        height: 5%;
        margin-bottom: 5px;
        //border:1px solid red;
    }
    .we-client-swiper-slide img{
        width: 75%;
        height: 80%;
        //border:1px solid red;
        margin-left: 14px;
        //border:1px solid red;
    }
    .swiper-wrapper{
        -moz-transition-timing-function: linear !important;
        -webkit-transition-timing-function: linear !important;
        -ms-transition-timing-function: linear !important;
        -o-transition-timing-function: linear !important;
        transition-timing-function: linear !important;
    }

</style>
